import { AppTopBar } from 'components/AppTopBar';
import { getTrans } from 'modules/i18n';
import { useWeekPeriod } from 'modules/week-details';
import { getWeekLabelWithTimezone } from 'modules/work-weeks';
import { DEFAULT_TIMEZONE } from 'utils/date';
import { useReason } from '../hooks';

export const ReasonPageHeader = () => {
  const { weekPeriod, isLoading } = useWeekPeriod();
  const { reason, isError } = useReason();

  const title = getTrans('pageTitles.reasonDetails');

  if (isLoading) {
    return <AppTopBar variant="back" title={title} />;
  }

  if (!weekPeriod || !reason || isError) {
    return <AppTopBar variant="back" />;
  }

  const start = weekPeriod.calendarWeekStart;
  const end = weekPeriod.calendarWeekEnd;
  const dateLabelWithTimezone =
    start && end ? getWeekLabelWithTimezone(start, end, DEFAULT_TIMEZONE) : '';

  return (
    <AppTopBar variant="back" title={title} subtitle={dateLabelWithTimezone} />
  );
};
